'use client';

import { c as _c } from "react/compiler-runtime";
import { useDebouncedCallback } from '@repo/sdk/pacer';
import { parseAsInteger, parseAsString, useQueryState } from '@repo/sdk/qs';
import { Button, Input, TableSettings } from '@repo/ui/components';
import { Plus, Search } from 'lucide-react';
import Link from 'next/link';
import { useEffect } from 'react';
const DefaultChildren = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Plus />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button asChild={true} className="max-sm::size-10"><Link href="/quotes/new">{t0} <span className="font-semibold max-sm:hidden">New Quote</span></Link></Button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const SearchBar = t0 => {
  const $ = _c(19);
  const {
    children: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? DefaultChildren() : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const children = t2;
  const [searchTerm, setSearchTerm] = useQueryState("search", parseAsString);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = parseAsInteger.withDefault(1);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [, setPage] = useQueryState("page", t3);
  let t4;
  if ($[3] !== setPage) {
    t4 = () => {
      setPage(1);
    };
    $[3] = setPage;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== searchTerm) {
    t5 = [searchTerm];
    $[5] = searchTerm;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== setSearchTerm) {
    t6 = async value => {
      await setSearchTerm(value);
    };
    $[7] = setSearchTerm;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      wait: 300
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const setDebouncedSearchTerm = useDebouncedCallback(t6, t7);
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <TableSettings />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = searchTerm ?? undefined;
  let t10;
  if ($[11] !== setDebouncedSearchTerm) {
    t10 = e => setDebouncedSearchTerm(e.target.value);
    $[11] = setDebouncedSearchTerm;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <div className="flex items-center gap-2">{t8}<Input className="lg:w-56" defaultValue={t9} EndIcon={Search} onChange={t10} placeholder="Search" /></div>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== children || $[17] !== t11) {
    t12 = <div className="flex w-full items-center justify-end gap-2">{children}{t11}</div>;
    $[16] = children;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};